// export const BASE_URL = "http://localhost:8000/api";
export const BASE_URL = "https://api.airlytics.io/api";
// export const GOOGLE_MAP_API_KEY = "AIzaSyCuzWiJAZhg7yXYqfi9-U70RQ9pGYGnA_I";
export const GOOGLE_MAP_API_KEY = "AIzaSyDsQdeEsFKjK9AbGFJLEEDlm_1DRBguMTE";
// export const BASE_URL = "http://144.126.223.136:8000";
// export const BASE_URL = "http://69.30.217.154:8000/api";
// export const BASE_URL = "https://airlytics.io/api";
